import { Component, input, model, output } from '@angular/core';
import { IconNames } from '@icon/assets';
import { UIIconComponent } from '@design-system';

export type SymbolDetailTabId = 'details' | 'orders' | 'trade-history' | 'messages' | 'more';

export interface SymbolDetailTab {
	id: SymbolDetailTabId;
	label: string;
	icon: IconNames;
	/** Filled variant used while the tab is selected; `icon` is reused when a family has none. */
	activeIcon?: IconNames;
}

/** Page is RTL, so the first entry renders right-most — the order the Figma sheet reads. */
export const SYMBOL_DETAIL_TABS: readonly SymbolDetailTab[] = [
	{ id: 'details', label: 'جزئیات', icon: 'symbol-detail', activeIcon: 'symbol-detail-fill' },
	{ id: 'orders', label: 'سفارش‌ها', icon: 'basket', activeIcon: 'basket-fill' },
	{ id: 'trade-history', label: 'سابقه معاملات', icon: 'time', activeIcon: 'time-fill' },
	{ id: 'messages', label: 'پیام‌ها', icon: 'comment-load', activeIcon: 'comment-load-fill' },
	{ id: 'more', label: 'بیشتر', icon: 'menu-horizontal' }
] as const;

@Component({
	selector: 'app-symbol-detail-tabs',
	templateUrl: './symbol-detail-tabs.component.html',
	imports: [UIIconComponent],
	host: {
		class: 'block w-full shrink-0'
	}
})
export class SymbolDetailTabsComponent {
	readonly tabs = input<readonly SymbolDetailTab[]>(SYMBOL_DETAIL_TABS);
	readonly activeTab = model<SymbolDetailTabId>('details');

	readonly moreSelected = output<void>();

	onTabClick(tab: SymbolDetailTab): void {
		if (tab.id === 'more') {
			this.moreSelected.emit();
			return;
		}

		this.activeTab.set(tab.id);
	}
}
